import { createSlice } from '@reduxjs/toolkit';
import {
    getHomePageData,
    getContactUsData,
    getNavbarData,
    getMetaData,
    getAboutData,
    getEnterprisesData
} from "../actions/app";

const initialState = {
    metaData: null,
    homePageData: null,
    contactUsData: null,
    navbarData: null,
    aboutData: null,
    enterprisesData: null,
    error: null,
    status:{
        metaData: 'idle',
        homePageData: 'idle',
        contactUsData: 'idle',
        navbarData: 'idle',
        aboutData: 'idle',
        enterprisesData: 'idle',
    }
};

const actionKeyMap = {
    getHomePageData: 'homePageData',
    getContactUsData:'contactUsData',
    getNavbarData: 'navbarData',
    getAboutData: 'aboutData',
    getEnterprisesData: 'enterprisesData',
    getMetaData: 'metaData',
}

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        const handlePending = (state, action) => {
            const key = actionKeyMap[action.type.split('/')[1]];
            if (key){
                state.status[key] = 'loading';
            }

        };

        const handleFulfilled = (state, action) => {
            const key = actionKeyMap[action.type.split('/')[1]];
            if (key){
                state[key] = action.payload;
                state.status[key] = 'success';
            }

        };

        const handleRejected = (state, action) => {
            const key = actionKeyMap[action.type.split('/')[1]];
            if (key){
                state.status[key] = 'failed';
                state.error = action.payload;
            }
        };

        const actions = [
            getHomePageData,
            getContactUsData,
            getNavbarData,
            getAboutData,
            getEnterprisesData,
            getMetaData
        ];

        actions.forEach(action => {
            builder
                .addCase(action.pending, handlePending)
                .addCase(action.fulfilled, handleFulfilled)
                .addCase(action.rejected, handleRejected);
        });
    }
});

export default appSlice.reducer;
